module.exports = __webpack_public_path__ + "static/media/about3.a1db2e0a.jpg";